export default {
  productPurchasePrices: [],
  productPurchasePrice: undefined,
};
